import { render, staticRenderFns } from "./TasksTable.vue?vue&type=template&id=78c9d061&scoped=true&"
import script from "./TasksTable.vue?vue&type=script&lang=js&"
export * from "./TasksTable.vue?vue&type=script&lang=js&"
import style0 from "./TasksTable.vue?vue&type=style&index=0&id=78c9d061&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c9d061",
  null
  
)

export default component.exports